(function () {
  const observer = new MutationObserver(() => {
    const iframe = document.getElementById('merchantwidgetiframe');
    if (iframe) {
      iframe.setAttribute(
        'title',
        'Shopping assistance and merchant promotions'
      );
      iframe.setAttribute(
        'aria-label',
        'Shopping assistance and merchant promotions'
      );
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

document.addEventListener('DOMContentLoaded', function() {
  const wishlistButton = document.querySelector('.swym-icon.heart-unfilled.swym-header-launcher-icon');
  
  if (wishlistButton && wishlistButton.getAttribute('role') === 'button') {
    if (!wishlistButton.getAttribute('aria-label') && 
        !wishlistButton.getAttribute('aria-labelledby') &&
        !wishlistButton.textContent.trim()) {
      wishlistButton.setAttribute('aria-label', 'Wishlist');
    }
  }
});

(function() {
  'use strict';
  
  function fixSwymCloseButtons() {
    const closeButtons = document.querySelectorAll('.swym-storefront-layout-action-close-button');
    
    closeButtons.forEach(function(btn) {
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Close');
      }
    });
  }
  
  function fixSwymMenus() {
    const tooltipOptions = document.getElementById('swym-storefront-layout-action-tooltip-options');
    if (tooltipOptions) {
      tooltipOptions.removeAttribute('role');
      tooltipOptions.setAttribute('role', 'tooltip');
    }
  }
  
  function runAllFixes() {
    fixSwymCloseButtons();
    fixSwymMenus();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAllFixes);
  } else {
    runAllFixes();
  }
  
  setTimeout(runAllFixes, 1000);
  setTimeout(runAllFixes, 3000);
  setTimeout(runAllFixes, 5000);
  
})();

(function() {
  'use strict';
  
  var fixedElements = new WeakSet();
  
  function fixAddonCheckboxes() {
    var fixed = 0;
    var alreadyFixed = 0;
    
    document.querySelectorAll('.custom-checkbox').forEach(function(label) {
      if (fixedElements.has(label)) {
        alreadyFixed++;
        return;
      }
      
      var checkbox = label.querySelector('.addon-checkbox');
      var checkmark = label.querySelector('.checkmark');
      var existingHidden = label.querySelector('.visually-hidden');
      
      if (!checkbox || !checkmark) return;
      
      if (existingHidden && existingHidden.textContent.trim()) {
        fixedElements.add(label);
        alreadyFixed++;
        return;
      }
      
      var addonProduct = label.closest('.addon-product');
      var titleElement = addonProduct ? addonProduct.querySelector('.addon-product__title') : null;
      var productTitle = titleElement ? titleElement.textContent.trim() : 'addon product';
      
      if (existingHidden && !existingHidden.textContent.trim()) {
        existingHidden.remove();
      }

      if (
        checkbox.hasAttribute('aria-label') ||
        checkbox.hasAttribute('aria-labelledby')
      ) {
        fixedElements.add(label);
        return;
      }

      var span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = 'Add ' + productTitle;
      span.setAttribute('data-injected', 'true');
      
      if (checkmark.nextSibling) {
        checkmark.parentNode.insertBefore(span, checkmark.nextSibling);
      } else {
        label.appendChild(span);
      }
      
      fixedElements.add(label);
      fixed++;
    });
  }
  
  fixAddonCheckboxes();
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAddonCheckboxes);
  }
  
  var intervals = [100, 300, 500, 1000, 2000, 3000, 5000];
  intervals.forEach(function(delay) {
    setTimeout(fixAddonCheckboxes, delay);
  });
  
  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var needsCheck = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            if ((node.classList && node.classList.contains('addon-product')) ||
                (node.querySelector && node.querySelector('.addon-product'))) {
              needsCheck = true;
            }
          }
        });
      });
      
      if (needsCheck) {
        setTimeout(fixAddonCheckboxes, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  ['scroll', 'click', 'touchstart'].forEach(function(eventType) {
    document.addEventListener(eventType, function() {
      setTimeout(fixAddonCheckboxes, 100);
    }, { once: true, passive: true });
  });
  
})();